import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { CLEAR_LOADING, SET_LOADING, SET_MESSAGE } from '../../actions/utils';
import { findBySeq, save } from './api';
import { useFormik } from 'formik';
import { CORPORATE_LEAD_ERRORS, useCorporateValidationSchema } from './New';
import CorporateLeadForm from './CorporateLeadForm';
import axios from 'axios';
import history from '../../store/history';
import { CORPORATE_LEAD_LIST } from '../../Routes';
import * as _ from 'lodash';

export default function (props) {
  const { seq } = useParams();
  const [state, setState] = useState({ values: {} });
  const dispatch = useDispatch();
  const validationSchema = useCorporateValidationSchema(props);
  const formProps = useFormik({
    initialValues: state.values,
    onSubmit: (values, helper) => {
      save({ ...values, draft: false })
        .then(() => history.push(CORPORATE_LEAD_LIST))
        .catch((err) => {
          let errors = _.values(err.response.data).map((e) => ({
            code: e,
            message: CORPORATE_LEAD_ERRORS[e] || CORPORATE_LEAD_ERRORS['DEFAULT'],
          }));
          dispatch({ type: SET_MESSAGE, payload: 'ERROR', errors });
          helper.setSubmitting(false);
        });
    },
    validationSchema,
    enableReinitialize: true,
  });
  const TOList = useSelector((state) => state?.lookup?.to);
  const to = TOList?.filter((e) => e.code === state?.values?.bankOfficeCode)?.[0] || {};
  const BOList = useSelector((state) => state?.lookup?.bo);
  const bo = BOList?.filter((e) => e.code === state?.values?.bankBranchCode)?.[0] || {};
  const [DOBList, setDOBList] = useState([]);
  const FSCList = useSelector((state) => state?.lookup?.fsc || []);

  useEffect(() => {
    let bankBranchCode = state?.values?.bankOfficeCode;
    if (bankBranchCode) {
      axios
        .get(`/api/agents?bank-branch-code=${bankBranchCode}`)
        .then((response) => {
          let agentList = response?.data?.content || [];
          let DOBList = agentList?.filter((e) => 'DOB' === e.agentDesignation);
          DOBList = !DOBList?.length ? agentList?.filter((e) => 'RDOB' === e.agentDesignation) : DOBList;
          DOBList =
            DOBList?.map((e) => ({
              value: e.agentId,
              label: e.agentName,
            })) || [];
          setDOBList(DOBList);
        })
        .catch((error) => console.log(error));
    }
  }, [to]);

  useEffect(() => {
    dispatch({ type: SET_LOADING, payload: true });
    findBySeq(seq)
      .then((res) => {
        setState((prevState) => ({ ...prevState, values: res.data }));
      })
      .catch(() => {
        dispatch({ type: SET_MESSAGE, payload: 'ERROR' });
      })
      .finally(() => {
        dispatch({ type: CLEAR_LOADING });
      });
  }, []);

  const readOnly = !state.values.draft;

  return (
    <div className='mt-3'>
      <div className='container'>
        <CorporateLeadForm
          readOnly={readOnly}
          {...formProps}
          office={{ ...to, bizCode: to.businessCode }}
          branch={{ ...bo, bizCode: bo.businessCode }}
          FSCList={FSCList}
          DOBList={DOBList}
        />
      </div>
    </div>
  );
}
